import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/** Removes query parameters from the address in place, keeping the rest of it, the hash and history state. */
export default function useDropSearchParam(): (...params: string[]) => void {
  const navigate = useNavigate();
  const { pathname, search, hash, state } = useLocation();
  return useCallback(
    (...params: string[]) => {
      const rest = new URLSearchParams(search);
      params.forEach((param) => rest.delete(param));
      navigate({ pathname, search: rest.toString(), hash }, { replace: true, state });
    },
    [navigate, pathname, search, hash, state]
  );
}
